import React from 'react';
import Spinner from 'react-spinkit';
import { Tooltip } from 'react-tooltip';
//interface
import { IButton } from './interface';

//components
import { useCustomEvent } from 'components/ApplicationInsights';
import { eventName } from 'components/ApplicationInsights/eventNames';
//utils
import { generateRandomId } from 'utils/GenerateRandomId';

import './styles.scss';

export const Button: React.FC<IButton> = (propsDefined) => {
  const {
    trackName,
    trackAction,
    onClick,
    hide,
    tooltip,
    toolTipPlace,
    tabIndex,
    className,
    disabled,
    isRequesting,
    form,
    width,
    height,
    style,
    spinnerColorClass,
    spinnerColor,
    children,
    title,
    role,
    html,
    testId,
    ...props
  } = propsDefined;

  const componentName = `Button`;
  const trackMenuClick = useCustomEvent(componentName, setTrackAction());
  const tooltipId = generateRandomId("ReactTooltip");

  function setTrackAction() {
    if (trackAction) {
      return trackAction;
    } else {
      if (window.location.pathname === '/cotacoes') {
        return eventName.COTACOES;
      } else {
        return eventName.PEDIDOS;
      }
    }
  }

  const handleConditionClick = () => {
    if (trackName) {
      trackMenuClick({ item: trackName });
    }

    handleOnClick();
  };

  const handleOnClick = () => {
    if (onClick !== undefined || onclick !== null) {
      onClick();
    }
  };

  const colorSpinner = spinnerColorClass ? undefined : spinnerColor || '#FFFFFF';

  return hide ? (
    <></>
  ) : (
    <>
      <button
        role={role || 'button'}
        data-tooltip-content={tooltip || undefined}
        data-tooltip-id={tooltipId}
        data-tooltip-place={toolTipPlace || 'top'}
        data-tooltip-html={tooltip || undefined}
        data-testid={testId}
        tabIndex={tabIndex || undefined}
        className={`button ${className}`}
        disabled={disabled || isRequesting}
        onClick={() => handleConditionClick()}
        form={form || ''}
        style={{
          width: width || undefined,
          height: height || undefined,
          ...style,
        }}
        title={title || ''}
        {...props}
      >
        {isRequesting &&
          <Spinner
            name="circle"
            className={spinnerColorClass || ''}
            color={colorSpinner}
            fadeIn="none"
          />
        }

        {!isRequesting && children}
      </button>

      {tooltip && <Tooltip id={tooltipId} variant="light" />}
    </>
  );
};
